"use strict";

angular.module("vendor")
.factory("Catalog", function($resource, FlashBag, $http, appConfig) {
    var catalogListingService = $resource(appConfig.API_SERVER + "/catalog/vendor/list/", {}, {
        query: {
            method: "GET",
            isArray: false
        }
    });
    var catalogEditService = $resource(appConfig.API_SERVER + "/catalog/vendor/:id/", {
        id: "@id"
    }, {
        get: {
            method: "GET",
            isArray: false
        },
        save: {
            method: "POST"
        },
        update: {
            method: "PUT"
        },
        patch: {
            method: "PATCH",
            ignoreLoadingBar: true
        },
        delete: {
            method: "DELETE"
        }
    });
    return {
        query: function(search, page) {
            var params = {
                search: search,
                page: page
            };
            return catalogListingService.query(params,
                function onSuccess(data) {
                },
                function onError(response) {
                    FlashBag.apiError(response);
                }
            );
        },
        get: function(id) {
            var params = {
                id: id
            };
            return catalogEditService.get(params,
                function onSuccess(data) {
                },
                function onError(response) {
                    FlashBag.apiError(response);
                }
            );
        },
        save: function(data) {
            if (data.id) {
                return data.$update();
            }
            else {
                var catalog = new catalogEditService(data);
                return catalog.$save();
            }
        },
        patch: function(data) {
            var catalog = new catalogEditService(data);
            return catalog.$patch();
        },
        delete: function(id) {
            return catalogEditService.delete({id: id},
                function onSuccess(data) {
                },
                function onError(response) {
                    FlashBag.alertWithContainer("danger", "flash-catalog", response.data.detail);
                    $("html, body").animate({scrollTop: 0}, "slow");
                }
            ).$promise;
        },
        getStatus: function(id) {
            var catalogStatusService = $resource(appConfig.API_SERVER + "/catalog/vendor/status/", {}, {
                query: {
                    method: "GET",
                    isArray: true
                }
            });
            var params;

            if (id) {
                params = {
                    id: id
                };
            }
            else {
                params = {
                    new_catalog: 1
                };
            }

            return catalogStatusService.query(params,
                function onSuccess(data) {
                },
                function onError(response) {
                    FlashBag.apiError(response);
                }
            );
        },
        importCatalogs: function(data) {
            return $http.post(appConfig.API_SERVER + "/import/catalogs/", data, {
                transformRequest: angular.identity,
                headers: {"Content-Type": undefined}
            })
        }
    }
})

.factory("CatalogSharing", function($http, appConfig) {
    return {
        import: function(data) {
            return $http.post(appConfig.API_SERVER + "/import/catalog-sharing/", data, {
                transformRequest: angular.identity,
                headers: {"Content-Type": undefined}
            })
        }
    }
})

.factory("CatalogSharingAuthorizedCustomer", function($resource, FlashBag, gettextCatalog, CatalogBuyer, appConfig) {
        var catalogAddBuyerListing = $resource(appConfig.API_SERVER + "/catalog/vendor/add-authorized-customers/:id/", {id: "@id"}, {
            query: {
                method: "GET",
                isArray: false
            },
            save: {
                method: "POST"
            },
            update: {
                method: "PATCH",
                ignoreLoadingBar: true
            }
        });
        var catalogManageBuyerListing = $resource(appConfig.API_SERVER + "/catalog/vendor/manage-authorized-customers/list/:id/", {id: "@id"}, {
            query: {
                method: "GET",
                isArray: false
            },
            save: {
                method: "POST"
            },
            update: {
                method: "PATCH",
                ignoreLoadingBar: true
            }
        });
        var catalogInviteSelected = $resource(appConfig.API_SERVER + "/catalog/vendor/authorized-selected-customers/invite/", {}, {
            save: {
                method: "POST",
                ignoreLoadingBar: true
            }
        });
        var selectedSendReminder = $resource(appConfig.API_SERVER + "/catalog/vendor/authorized-selected-customers/send-reminder/");
        var selectedDelete = $resource(appConfig.API_SERVER + "/catalog/vendor/authorized-selected-customers/delete/");
        var selectedEnable = $resource(appConfig.API_SERVER + "/catalog/vendor/authorized-selected-customers/enable/");

        function getBulkActionParams() {
            return {
                delete: {
                    text: gettextCatalog.getString("Delete selected"),
                    message: gettextCatalog.getString("Do you really want to delete these catalog accesses?"),
                    resource: selectedDelete,
                    modalTemplatePrefix: "partnership",
                    modalTemplatePackage: "vendor"
                },
                enable: {
                    text: gettextCatalog.getString("Enable selected"),
                    resource: selectedEnable,
                    modalTemplatePrefix: "partnership",
                    modalTemplatePackage: "vendor"
                },
                disable: {
                    text: gettextCatalog.getString("Disable selected"),
                    resource: selectedEnable,
                    modalTemplatePrefix: "partnership",
                    modalTemplatePackage: "vendor"
                },
                send_reminder: {
                    text: gettextCatalog.getString("Send reminder"),
                    resource: selectedSendReminder,
                    modalTemplatePrefix: "partnership-send-reminder",
                    modalTemplatePackage: "vendor"
                }
            };
        }

        function getSortFields() {
            return {
                company_name: {
                    name: gettextCatalog.getString("Name"),
                    normal: gettextCatalog.getString("A to Z"),
                    reverse: gettextCatalog.getString("Z to A")
                },
                buyer_number: {
                    name: gettextCatalog.getString("Customer #"),
                    normal: gettextCatalog.getString("0 to 9"),
                    reverse: gettextCatalog.getString("9 to 0")
                },
                status_date: {
                    name: gettextCatalog.getString("Status Date"),
                    normal: gettextCatalog.getString("Past to Future"),
                    reverse: gettextCatalog.getString("Future to Past")
                }
            };
        }

        function getFilter() {
            var values = [];
            var filterValues = getFilterValues();

            angular.forEach(filterValues, function(value, key) {
                values.push({
                    Value: key,
                    Name: value
                });
            });

            return values;
        }

        return {
            query: function(catalog_id, search, page, ordering, filters) {
                ordering = ordering || "company_name";
                var params = {
                    search: search,
                    page: page,
                    reference_id: catalog_id,
                    ordering: ordering
                };

                params = angular.extend(params, filters);

                return catalogAddBuyerListing.query(params,
                    function onSuccess(data) {
                    },
                    function onError(response) {
                        FlashBag.apiError(response);
                    }
                );
            },
            updateAllSelected: function(catalog_id, search, selected, ordering, page, filters) {
                ordering = ordering || "company_name";
                var params = {
                    search: search,
                    reference_id: catalog_id,
                    selected: selected,
                    ordering: ordering,
                    page: page
                };

                params = angular.extend(params, filters);

                return catalogAddBuyerListing.save(params,
                    function onSuccess(data) {
                    },
                    function onError(response) {
                        FlashBag.apiError(response);
                    }
                );
            },
            updateSingleSelected: function(catalog_id, selected, id) {
                var params = {
                    reference_id: catalog_id,
                    selected: selected,
                    id: id
                };
                return catalogAddBuyerListing.update(params,
                    function onSuccess(data) {
                    },
                    function onError(response) {
                        FlashBag.apiError(response);
                    }
                );
            },
            updateAuthorizedAllSelected: function(catalog_id, search, selected, ordering, page, filters) {
                ordering = ordering || "company_name";
                var params = {
                    search: search,
                    reference_id: catalog_id,
                    selected: selected,
                    ordering: ordering,
                    page: page
                };

                params = angular.extend(params, filters);

                return catalogManageBuyerListing.save(params,
                    function onSuccess(data) {
                    },
                    function onError(response) {
                        FlashBag.apiError(response);
                    }
                );
            },
            updateAuthorizedSingleSelected: function(catalog_id, selected, id) {
                var params = {
                    reference_id: catalog_id,
                    selected: selected,
                    id: id
                };
                return catalogManageBuyerListing.update(params,
                    function onSuccess(data) {
                    },
                    function onError(response) {
                        FlashBag.apiError(response);
                    }
                );
            },
            queryAuthorized: function(catalog_id, search, page, ordering, filters) {
                ordering = ordering || "company_name";
                var params = {
                    search: search,
                    page: page,
                    reference_id: catalog_id,
                    ordering: ordering
                };

                params = angular.extend(params, filters);

                return catalogManageBuyerListing.query(params,
                    function onSuccess(data) {
                    },
                    function onError(response) {
                        FlashBag.apiError(response);
                    }
                );
            },
            // TODO WEG-1203 inviteSelected should be in a service different of 'manage'
            inviteSelected: function(catalog_id, invite) {
                var params = {
                    reference_id: catalog_id,
                    invite: invite
                };
                return catalogInviteSelected.save(params);
            },
            // TODO WEG-1203 getAddSectionSelected should be in a service different of 'manage'
            getAddSectionSelected: function(catalog_id) {
                var params = {
                    reference_id: catalog_id
                };

                return catalogInviteSelected.query(params);
            },
            updateState: function(id, enabled) {
                return CatalogBuyer.updateState(id, enabled);
            },
            getSortFields: getSortFields,
            getFilter: getFilter,
            getBulkActionParams: getBulkActionParams,
            getSingleActionParams: getBulkActionParams
        }
    }
)

// TODO WEG-1875 Refactor into abstract service when we have time
.factory("CatalogSharingGroupPartnershipAddCustomer", function(
    $resource, FlashBag, gettextCatalog, CatalogSharingGroupAuthorizedManageCustomer, appConfig
){
    var catalogAddGroupPartnershipCustomerListing = $resource(appConfig.API_SERVER + "/catalog/vendor/community/add-authorized-partnerships/:id/", {id: "@id"}, {
        query: {
            method: "GET",
            isArray: false
        },
        save: {
            method: "POST"
        },
        update: {
            method: "PATCH",
            ignoreLoadingBar: true
        }
    });
    var catalogManageGroupPartnershipCustomerListing = $resource(appConfig.API_SERVER + "/catalog/vendor/community/manage-authorized-customers/list/:id/", {id: "@id"}, {
        query: {
            method: "GET",
            isArray: false
        },
        save: {
            method: "POST"
        },
        update: {
            method: "PATCH",
            ignoreLoadingBar: true
        }
    });

    var catalogInviteGroupPartnershipSelected = $resource(appConfig.API_SERVER + "/catalog/vendor/community/authorized-selected-partnerships/invite/", {}, {
        query: {
            method: "GET",
            isArray: true
        },
        save: {
            method: "POST"
        }
    });
    var selectedSendReminder = $resource(appConfig.API_SERVER + "/catalog/vendor/community/authorized-selected-partnerships/send-reminder/");
    var selectedDelete = $resource(appConfig.API_SERVER + "/catalog/vendor/community/authorized-selected-customers/delete/");
    var selectedEnable = $resource(appConfig.API_SERVER + "/catalog/vendor/community/authorized-selected-customers/enable/")

    function getBulkActionParams() {
        return {
            delete: {
                text: gettextCatalog.getString("Delete selected"),
                message: gettextCatalog.getString("Do you really want to delete these catalog group accesses?"),
                resource: selectedDelete,
                modalTemplatePrefix: "partnership",
                modalTemplatePackage: "vendor"
            },
            enable: {
                text: gettextCatalog.getString("Enable selected"),
                resource: selectedEnable,
                modalTemplatePrefix: "partnership",
                modalTemplatePackage: "vendor"
            },
            disable: {
                text: gettextCatalog.getString("Disable selected"),
                resource: selectedEnable,
                modalTemplatePrefix: "partnership",
                modalTemplatePackage: "vendor"
            },
            send_reminder: {
                text: gettextCatalog.getString("Send reminder"),
                resource: selectedSendReminder,
                modalTemplatePrefix: "group-partnership-send-reminder",
                modalTemplatePackage: "vendor"
            }
        };
    }

    function getSortFields() {
        return {
            company_name: {
                name: gettextCatalog.getString("Name"),
                normal: gettextCatalog.getString("A to Z"),
                reverse: gettextCatalog.getString("Z to A")
            }
        };
    }

    return {
        query: function(catalog_link_id, search, page, ordering, filters) {
            ordering = ordering || "company_name";
            var params = {
                search: search,
                page: page,
                reference_id: catalog_link_id,
                ordering: ordering
            };
            params = angular.extend(params, filters);

            return catalogAddGroupPartnershipCustomerListing.query(params,
                function onSuccess(data) {
                },
                function onError(response) {
                    FlashBag.apiError(response);
                }
            );
        },
        updateAllSelected: function(catalog_link_id, search, selected, ordering, page, filters) {
            ordering = ordering || "company_name";
            var params = {
                search: search,
                reference_id: catalog_link_id,
                selected: selected,
                ordering: ordering,
                page: page
            };
            params = angular.extend(params, filters);

            return catalogAddGroupPartnershipCustomerListing.save(params,
                function onSuccess(data) {
                },
                function onError(response) {
                    FlashBag.apiError(response);
                }
            );
        },
        updateSingleSelected: function(catalog_link_id, selected, id) {
            var params = {
                reference_id: catalog_link_id,
                selected: selected,
                id: id
            };
            return catalogAddGroupPartnershipCustomerListing.update(params,
                function onSuccess(data) {
                },
                function onError(response) {
                    FlashBag.apiError(response);
                }
            );
        },
        updateAuthorizedAllSelected: function(catalog_link_id, search, selected, ordering, page, filters) {
            ordering = ordering || "company_name";
            var params = {
                search: search,
                reference_id: catalog_link_id,
                selected: selected,
                ordering: ordering,
                page: page
            };
            params = angular.extend(params, filters);

            return catalogManageGroupPartnershipCustomerListing.save(params,
                function onSuccess(data) {
                },
                function onError(response) {
                    FlashBag.apiError(response);
                }
            );
        },
        updateAuthorizedSingleSelected: function(catalog_link_id, selected, id) {
            var params = {
                reference_id: catalog_link_id,
                selected: selected,
                id: id
            };
            return catalogManageGroupPartnershipCustomerListing.update(params,
                function onSuccess(data) {
                },
                function onError(response) {
                    FlashBag.apiError(response);
                }
            );
        },
        queryAuthorized: function(catalog_link_id, search, page, ordering, filters) {
            ordering = ordering || "company_name";
            var params = {
                search: search,
                page: page,
                reference_id: catalog_link_id,
                ordering: ordering
            };
            params = angular.extend(params, filters);

            return catalogManageGroupPartnershipCustomerListing.query(params,
                function onSuccess(data) {
                },
                function onError(response) {
                    FlashBag.apiError(response);
                }
            );
        },
        // TODO WEG-1203 inviteSelected should be in a service different of 'manage'
        inviteSelected: function(catalog_link_id, invite) {
            var params = {
                reference_id: catalog_link_id,
                invite: invite
            };
            return catalogInviteGroupPartnershipSelected.save(params);
        },
        // TODO WEG-1203 getAddSectionSelected should be in a service different of 'manage'
        getAddSectionSelected: function(catalog_link_id) {
            var params = {
                reference_id: catalog_link_id
            };

            return catalogInviteGroupPartnershipSelected.query(params);
        },
        updateState: function(id, enabled) {
            return CatalogSharingGroupAuthorizedManageCustomer.updateState(id, enabled);
        },
        getSortFields: getSortFields,
        getBulkActionParams: getBulkActionParams,
        getSingleActionParams: getBulkActionParams
    }
})

.factory("CatalogSharingGroupAuthorizedAddCustomer", function(
    $resource, FlashBag, gettextCatalog, CatalogSharingGroupAuthorizedManageCustomer, appConfig
) {
    var catalogAddGroupBuyerListing = $resource(appConfig.API_SERVER + "/catalog/vendor/community/add-authorized-customers/:id/", {id: "@id"}, {
        query: {
            method: "GET",
            isArray: false
        },
        save: {
            method: "POST"
        },
        update: {
            method: "PATCH",
            ignoreLoadingBar: true
        }
    });
    var catalogManageGroupBuyerListing = $resource(appConfig.API_SERVER + "/catalog/vendor/community/manage-authorized-customers/list/:id/", {id: "@id"}, {
        query: {
            method: "GET",
            isArray: false
        },
        save: {
            method: "POST"
        },
        update: {
            method: "PATCH",
            ignoreLoadingBar: true
        }
    });
    var catalogInviteSelected = $resource(appConfig.API_SERVER + "/catalog/vendor/community/authorized-selected-customers/invite/", {}, {
        query: {
            method: "GET",
            isArray: true
        },
        save: {
            method: "POST"
        }
    });
    var selectedSendReminder = $resource(appConfig.API_SERVER + "/catalog/vendor/community/authorized-selected-customers/send-reminder/");
    var selectedDelete = $resource(appConfig.API_SERVER + "/catalog/vendor/community/authorized-selected-customers/delete/");
    var selectedEnable = $resource(appConfig.API_SERVER + "/catalog/vendor/community/authorized-selected-customers/enable/");

    function getBulkActionParams() {
        return {
            delete: {
                text: gettextCatalog.getString("Delete selected"),
                message: gettextCatalog.getString("Do you really want to delete these catalog group accesses?"),
                resource: selectedDelete,
                modalTemplatePrefix: "partnership",
                modalTemplatePackage: "vendor"
            },
            enable: {
                text: gettextCatalog.getString("Enable selected"),
                resource: selectedEnable,
                modalTemplatePrefix: "partnership",
                modalTemplatePackage: "vendor"
            },
            disable: {
                text: gettextCatalog.getString("Disable selected"),
                resource: selectedEnable,
                modalTemplatePrefix: "partnership",
                modalTemplatePackage: "vendor"
            },
            send_reminder: {
                text: gettextCatalog.getString("Send reminder"),
                resource: selectedSendReminder,
                modalTemplatePrefix: "group-partnership-send-reminder",
                modalTemplatePackage: "vendor"
            }
        };
    }

    function getSortFields() {
        return {
            company_name: {
                name: gettextCatalog.getString("Name"),
                normal: gettextCatalog.getString("A to Z"),
                reverse: gettextCatalog.getString("Z to A")
            }
        };
    }

    return {
        query: function(catalog_link_id, search, page, ordering, filters) {
            ordering = ordering || "company_name";
            var params = {
                search: search,
                page: page,
                reference_id: catalog_link_id,
                ordering: ordering
            };
            params = angular.extend(params, filters);

            return catalogAddGroupBuyerListing.query(params,
                function onSuccess(data) {
                },
                function onError(response) {
                    FlashBag.apiError(response);
                }
            );
        },
        updateAllSelected: function(catalog_link_id, search, selected, ordering, page, filters) {
            ordering = ordering || "company_name";
            var params = {
                search: search,
                reference_id: catalog_link_id,
                selected: selected,
                ordering: ordering,
                page: page
            };
            params = angular.extend(params, filters);

            return catalogAddGroupBuyerListing.save(params,
                function onSuccess(data) {
                },
                function onError(response) {
                    FlashBag.apiError(response);
                }
            );
        },
        updateSingleSelected: function(catalog_link_id, selected, id) {
            var params = {
                reference_id: catalog_link_id,
                selected: selected,
                id: id
            };
            return catalogAddGroupBuyerListing.update(params,
                function onSuccess(data) {
                },
                function onError(response) {
                    FlashBag.apiError(response);
                }
            );
        },
        updateAuthorizedAllSelected: function(catalog_link_id, search, selected, ordering, page, filters) {
            ordering = ordering || "company_name";
            var params = {
                search: search,
                reference_id: catalog_link_id,
                selected: selected,
                ordering: ordering,
                page: page
            };
            params = angular.extend(params, filters);

            return catalogManageGroupBuyerListing.save(params,
                function onSuccess(data) {
                },
                function onError(response) {
                    FlashBag.apiError(response);
                }
            );
        },
        updateAuthorizedSingleSelected: function(catalog_link_id, selected, id) {
            var params = {
                reference_id: catalog_link_id,
                selected: selected,
                id: id
            };
            return catalogManageGroupBuyerListing.update(params,
                function onSuccess(data) {
                },
                function onError(response) {
                    FlashBag.apiError(response);
                }
            );
        },
        queryAuthorized: function(catalog_link_id, search, page, ordering, filters) {
            ordering = ordering || "company_name";
            var params = {
                search: search,
                page: page,
                reference_id: catalog_link_id,
                ordering: ordering
            };
            params = angular.extend(params, filters);

            return catalogManageGroupBuyerListing.query(params,
                function onSuccess(data) {
                },
                function onError(response) {
                    FlashBag.apiError(response);
                }
            );
        },
        // TODO WEG-1203 inviteSelected should be in a service different of 'manage'
        inviteSelected: function(catalog_link_id, invite) {
            var params = {
                reference_id: catalog_link_id,
                invite: invite
            };
            return catalogInviteSelected.save(params);
        },
        // TODO WEG-1203 getAddSectionSelected should be in a service different of 'manage'
        getAddSectionSelected: function(catalog_link_id) {
            var params = {
                reference_id: catalog_link_id
            };

            return catalogInviteSelected.query(params);
        },
        updateState: function(id, enabled) {
            return CatalogSharingGroupAuthorizedManageCustomer.updateState(id, enabled);
        },
        getSortFields: getSortFields,
        getBulkActionParams: getBulkActionParams,
        getSingleActionParams: getBulkActionParams
    }
})

.factory("CatalogSharingGroup", function($http, $resource, FlashBag, appConfig) {
    var catalogGroupLink = $resource(appConfig.API_SERVER + "/catalog/vendor/community/links/:id/", {id: "@id"}, {
        get: {
            method: "GET",
            ignoreLoadingBar: true
        },
        save: {
            method: "POST",
            ignoreLoadingBar: true
        },
        delete: {
            method: "DELETE",
            ignoreLoadingBar: true
        }
    });

    return {
        fetchGroupMemberships: function() {
            return $http({
                method: "GET",
                ignoreLoadingBar: true,
                url: appConfig.API_SERVER + "/catalog/vendor/community/memberships/"
            });
        },
        refreshSharingType: function(catalogId, sharingType) {
            return $http({
                method: "PATCH",
                ignoreLoadingBar: true,
                url: appConfig.API_SERVER + "/catalog/vendor/refresh-sharing-type/" + catalogId + "/",
                data: {
                    sharing_type: sharingType
                }
            });
        },
        refreshGroupSharingType: function(groupLinkId, sharingType) {
            return $http({
                method: "PATCH",
                ignoreLoadingBar: true,
                url: appConfig.API_SERVER + "/catalog/vendor/community/links/refresh-sharing-type/" + groupLinkId + "/",
                data: {
                    sharing_type: sharingType
                }
            });
        },
        refreshGroupRegionHasTargetedZones: function(groupLinkId) {
            return $http({
                method: "POST",
                ignoreLoadingBar: true,
                url: appConfig.API_SERVER + "/catalog/vendor/community/region/refresh-has-targeted-zones/",
                data: {
                    id: groupLinkId
                }
            });
        },
        getGroupLink: function(membershipId) {
            var params = {
                id: membershipId
            };
            return catalogGroupLink.get(params,
                function onSuccess(data) {
                },
                function onError(response) {
                    FlashBag.apiError(response);
                }
            );
        },
        saveGroupLink: function(catalogId, membershipId) {
            var params = {
                "membership": membershipId,
                "catalog": catalogId
            };
            var groupLink = new catalogGroupLink(params);
            return groupLink.$save();
        },
        removeGroupLink: function(catalogId, membershipId) {
            var params = {
                "id": membershipId,
                "catalog": catalogId
            };
            return catalogGroupLink.delete(params,
                function onSuccess(data) {
                },
                function onError(response) {
                    FlashBag.alertWithContainer("danger", "flash-catalog", response.data.detail);
                    $("html, body").animate({scrollTop: 0}, "slow");
                }
            );
        },
        calculatePopulation: function(catalogId, groupId, location) {
            return $http({
                method: "GET",
                ignoreLoadingBar: true,
                url: appConfig.API_SERVER + "/catalog/vendor/population/" + catalogId + "/",
                params: {
                    group_id: groupId,
                    location: location
                }
            });
        }
    }
})

.factory("CatalogClone", function($http, $state, $q, FlashBag, gettextCatalog, appConfig) {
    return {
        clone: function(catalog, form) {
            var deferred = $q.defer();

            function resolve(response) {
                FlashBag.alertWithContainer("success", "flash-catalog", gettextCatalog.getString("The catalog was successfully copied."));
                $state.go("catalogEdit", {
                    id: response.data.id,
                    forceModalRedirect: true
                });
                deferred.resolve(response);
            }

            function reject(response) {
                FlashBag.alertWithContainer("danger", "flash-catalog", FlashBag.messages.sorry());
                deferred.reject(response);
            }

            $http.post(appConfig.API_SERVER + "/catalog/vendor/clone/", {id: catalog.id}).then(resolve, reject);

            return deferred.promise;
        }
    }
})

.factory("CatalogSharingGroupAuthorizedManageCustomer", function($resource, $q, FlashBag, appConfig) {
    var resource = $resource(appConfig.API_SERVER + "/catalog/vendor/community/manage-authorized-customers/:id/", {
        id: "@id"
    }, {
        update: {
            method: "PUT"
        },
        delete: {
            method: "DELETE"
        }
    });

    return {
        get: function(id) {
            var params = {
                id: id
            };
            return resource.get(params,
                function onSuccess(data) {
                },
                function onError(response) {
                    FlashBag.apiError(response);
                }
            );

        },
        updateState: function(id, enabled) {
            var deferred = $q.defer();
            this.get(id).$promise.then(function(data) {
                data.enabled = enabled;
                data.$update().then(deferred.resolve, deferred.reject);
            });
            return deferred.promise;
        },
        delete: function(id) {
            return resource.delete({id: id},
                function onSuccess(data) {
                },
                function onError(response) {
                    FlashBag.alertWithContainer("danger", "flash-catalog", response.data.detail);
                    $("html, body").animate({scrollTop: 0}, "slow");
                }
            ).$promise;
        }
    };

});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/catalog/catalog.factory.js
// module id = 876
// module chunks = 0